import React from "react";
import { Card, RadioGroup } from "web-ui";
import { LegacyButton as Button } from "web-ui/legacy";

import styles from "../../styles/AudioGenerator/AudioGenerator.module.scss";

import type { AudioGenerationFlags, InputStyle } from "./AudioGenerator";

/* eslint-disable react/jsx-no-literals */
export const InputStyleScreen = ({
  onNext,
}: {
  onNext: (data: Partial<AudioGenerationFlags>) => void;
}) => {
  const [inputStyle, setInputStyle] = React.useState<InputStyle>();

  return (
    <>
      <h2>How much audio do you wish to generate?</h2>
      {/* @ts-expect-error Types don't match somehow */}
      <RadioGroup
        className={styles["card-group"]}
        onChange={event => setInputStyle(event.value as InputStyle)}
        value={inputStyle}
      >
        <Card role="radio" value="single">
          <div className={styles["card"]}>
            <h3>Single Piece</h3>
          </div>
        </Card>
        <Card role="radio" value="bulk">
          <div className={styles["card"]}>
            <h3>Multiple Pieces</h3>
          </div>
        </Card>
      </RadioGroup>
      <Button
        disabled={inputStyle === undefined}
        onClick={() => onNext({ inputStyle })}
        variant="solid"
      >
        Next
      </Button>
    </>
  );
};
